import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatProveedorComponent } from './chat-proveedor/chat-proveedor.component';

const routes: Routes = [
  {
    path: 'chat-proveedor',
    component: ChatProveedorComponent,
  },
  { path: '', redirectTo: 'chat-proveedor', pathMatch: 'prefix' },
  { path: '**', redirectTo: 'chat-proveedor', pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AsignarProveedorRoutingModule { }